import * as React from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { SectionsStatus } from '../components/SectionsStatus';
import { updateOrganizationProfileOperationDetailsNotifications } from '@pec/aion-ui-core/actions/changeOrganizationProfileNotifications';
import { useDispatch } from 'react-redux';
import { useOrganizationProfileNotifications } from '../hooks/useOrganizationProfileNotifications';

type Props = {
  isEnabled?: boolean;
  organizationId?: string;
};

export const CompanyProfileInfoGuard: React.FC<Props> = ({ isEnabled = true, organizationId, children }) => {
  const dispatch = useDispatch();
  const { statuses, isFetching } = useOrganizationProfileNotifications();
  const entries = statuses.operationDetailsSection.filter(([key]) =>
    [
      'operationRegionsIsCompleted',
      'operatingRegionsV2IsCompleted',
      'servicesIsCompleted',
      'industriesIsCompleted',
      'serviceCategoriesIsCompleted',
      'allServicesMatchBusinessType'
    ].includes(key)
  );
  const notCompleted = entries.map(entry => entry[1]).some(entry => entry === false);

  React.useEffect(() => {
    organizationId && isEnabled && dispatch(updateOrganizationProfileOperationDetailsNotifications(organizationId));
  }, [dispatch, organizationId, isEnabled]);

  if (isEnabled && !organizationId) {
    return null;
  }

  if (isEnabled && isFetching) {
    return (
      <Box display="flex" justifyContent="center" paddingTop={10} paddingBottom={10}>
        <CircularProgress />
      </Box>
    );
  }

  if (isEnabled && notCompleted) {
    return (
      <Box padding={3} paddingTop={3}>
        <SectionsStatus organizationId={organizationId} entries={entries} />
      </Box>
    );
  }

  return <>{children}</>;
};
